import TopWantedItem from "@/theme1/components/topWanted/TopWantedItem";

export default function TopWantedList({ products }) {
  return (
    <section aria-label="Top wanted product ranking">
      <div className="space-y-4 sm:space-y-5">
        {products.map((product, index) => (
          <TopWantedItem
            key={product.slug}
            product={product}
            index={index}
          />
        ))}
      </div>
    </section>
  );
}
